<mat-sidenav-container class="h-full bg-transparent">
  <mat-sidenav
    position="end"
    mode="side"
    [opened]="isOpen()"
    (openedChange)="isOpen.set($event)"
    class="activity-sidenav"
    fixedInViewport="true"
    [fixedTopGap]="0"
    [fixedBottomGap]="0">
    <aionz-side-panel
      [title]="panelTitle()"
      [subtitle]="panelSubtitle()"
      (closePanel)="close()">
      <mat-tab-group
        [mat-stretch-tabs]="false"
        [(selectedIndex)]="activeSidebarTabIndex"
        (selectedTabChange)="onSidebarTabChange($event)">
        <mat-tab label="Atividade">
          <aionz-purchase-request-activities-tab
            [activities]="activitiesData()"
            [isLoading]="activitiesLoadState() === LoadState.LOADING"
            [hasError]="activitiesLoadState() === LoadState.ERROR">
          </aionz-purchase-request-activities-tab>
        </mat-tab>
        <mat-tab [label]="commentsTabLabel()">
          <aionz-purchase-request-comments-tab
            [comments]="commentsData()"
            [isLoading]="commentsLoadState() === LoadState.LOADING"
            [hasError]="commentsLoadState() === LoadState.ERROR"
            [isSubmitting]="isCommentsSubmitting()"
            (commentSubmit)="handleCommentSubmit($event)">
          </aionz-purchase-request-comments-tab>
        </mat-tab>
      </mat-tab-group>
    </aionz-side-panel>
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content />
  </mat-sidenav-content>
</mat-sidenav-container>
